import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 16px;
  gap: 24px;
  width: 100%;
  background: #ffffff;
  border-radius: 8px;

  flex: none;
  align-self: stretch;
  flex-grow: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  gap: 8px;
  width: 100%;
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const Title = styled.div`
  font-family: 'Cera Pro';
  font-style: normal;
  font-weight: 950;
  font-size: 18px;
  line-height: 24px;
  color: #282828;
  flex: 1;
`;
export const DescriptionContainer = styled.div`
  padding-right: 40px;
`;

export const Description = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6a6a6a;
  flex: none;
  flex-grow: 0;
`;

export const RecommendedSetting = styled.div`
  font-size: 12px;
  font-weight: 500;
  display: flex;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #9ea9b1;
  margin-top: 10px;
`;
export const LearnMore = styled.a`
  font-style: normal;
  text-decoration: underline;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: #e6614c;
  flex: none;
  flex-grow: 0;
  padding-left: 4px;
`;

export const RecommendedSettingHref = styled.div`
  font-style: normal;
  text-decoration: underline;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  line-height: 20px;
  color: #e6614c;
  flex: none;
  flex-grow: 0;
  padding-left: 4px;

  :hover {
    color: #69b1ff;
    transition: color 0.3s;
  }
`;
